<kendo-window title="Erreur communication serveur" *ngIf="opened" (close)="close()" [minWidth]="250" [width]="450">
    <p>URL : {{erreur.requestUrl}}</p>
    <p>Erreur ID : {{erreur.erreurId}}</p>
    <p>Message : {{erreur.exceptionMessage}}</p>
</kendo-window>